var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconRepayments128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2256_9847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 66.5029C104 43.307 85.6701 24.5029 63.059 24.5029C51.6977 24.5029 41.4173 29.2504 34 36.917",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.5 76.5029L94 58.5029H113L103.5 76.5029Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 62.5029C23 85.6989 41.5918 104.503 64.5259 104.503C76.0495 104.503 86.4767 99.7555 94 92.0889",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 52.5029L34 70.5029H15L24.5 52.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7681 76.8457H65.9868",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9639 51.2461H71.2896",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1468 51.2461C58.1072 51.2461 54.8325 54.1115 54.8325 57.6461C54.8325 61.1807 58.1072 64.0461 62.1468 64.0461",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8039 64.0459C69.8434 64.0459 73.1182 66.9113 73.1182 70.4459C73.1182 73.9805 69.8434 76.8459 65.8039 76.8459",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9067 51.4316V43.9316",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9067 83.9316V76.4316",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9866 64.0459H62.0918",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2256_9847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconRepayments128);
export default __webpack_public_path__ + "static/media/pictogramBeaconRepayments128.00f9e4d39a0e31bb261239c618beb90c.svg";
export { ForwardRef as ReactComponent };